import script from "./CreatorPageEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorPageEditor.vue?vue&type=script&setup=true&lang=js"

import "./CreatorPageEditor.vue?vue&type=style&index=0&id=b5bc7232&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5bc7232"]])

export default __exports__